import { Directive, OnInit } from '@angular/core';
import {
  BaseSelectGridFilterDirective,
  FilterInput
} from '@app/pcs/shared/containers/search-results-grid/filters/base-select-grid-filter.directive';
import { Store } from '@ngrx/store';
import { getId, hasNoValue, isArray, isBoolean, isNotEmpty, isTrue } from '@util';
import { FilteringOptions, GridFilter } from 'ngrx-data-grid';
import * as R from 'ramda';

const toOptionIds = R.cond([
  [hasNoValue, R.always([])],
  [isArray, value => R.map(getId, value)],
  [R.T, value => [getId(value)]]
]);

const filterByOption = (option: FilteringOptions, optionIds: number[]) => R.cond([
  [
    R.equals(FilteringOptions.Contains),
    R.always(R.compose(isNotEmpty, R.intersection(optionIds)))
  ],
  [
    R.equals(FilteringOptions.NotContains),
    R.always(R.compose(R.isEmpty, R.intersection(optionIds)))
  ]
])(option);


@Directive()
export abstract class MultiSelectGridFilterDirective<T> extends BaseSelectGridFilterDirective<T> implements OnInit, GridFilter<FilterInput<T>> {

  showOnlyRowsWithNoOptions = false;
  selectedOptions: T[] = [];

  readonly options = [
    FilteringOptions.Contains,
    FilteringOptions.NotContains
  ];

  constructor(protected store?: Store<any>) {
    super(store);
  }

  ngOnInit(): void {
    if (isArray(this.value)) {
      this.selectedOptions = this.value;
    } else if (isBoolean(this.value)) {
      this.showOnlyRowsWithNoOptions = this.value;
      this.selectedOptions = [];
    }
    super.ngOnInit();
  }

  filter({option, value, rawValue}) {
    return isTrue(value)
      ? hasNoValue(rawValue)
      : filterByOption(option, toOptionIds(value))(toOptionIds(rawValue)) as boolean;
  }


  clear(): void {
    this.value = [];
  }

  onOptionSelected(options: T[]) {
    this.selectedOptions = options;
    this.valueChanged.emit(this.selectedOptions);
  }

  onShowOnlyRowsWithNoOptionsChanged(value) {
    this.showOnlyRowsWithNoOptions = value;
    if (this.showOnlyRowsWithNoOptions) {
      this.valueChanged.emit(this.showOnlyRowsWithNoOptions);
    } else {
      this.valueChanged.emit(this.selectedOptions);
    }
  }

}
